import { ThemedSider } from '@refinedev/antd'
import { useMenu } from '@refinedev/core'
import { theme } from 'antd'
import { useCallback, useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'

import iconBlack from '@/assets/icon-black.svg'
import iconWhite from '@/assets/icon-white.svg'
import logoBlack from '@/assets/logo-black.svg'
import logoWhite from '@/assets/logo-white.svg'
import { ResetCacheButton } from '@/components/layout/ResetCacheButton'
import { ThemeSwitcher } from '@/components/layout/ThemeSwitcher'
import { useThemeMode } from '@/hooks/useThemeMode'

export function CustomSider() {
  const { token } = theme.useToken()
  const { isDark } = useThemeMode()
  const navigate = useNavigate()
  const { menuItems } = useMenu()
  const siderRef = useRef<HTMLDivElement>(null)

  const handleSubmenuClick = useCallback(
    (e: MouseEvent) => {
      const title = (e.target as HTMLElement).closest?.(
        '.ant-menu-submenu-title',
      )
      if (!title) return

      const label = title.textContent?.trim()
      if (!label) return

      const section = menuItems.find(
        (item) => item.label === label && item.children.length > 0,
      )
      const firstChildRoute = section?.children[0]?.route
      if (firstChildRoute) {
        void navigate(firstChildRoute)
      }
    },
    [menuItems, navigate],
  )

  useEffect(() => {
    const el = siderRef.current
    if (!el) return
    el.addEventListener('click', handleSubmenuClick)
    return () => el.removeEventListener('click', handleSubmenuClick)
  }, [handleSubmenuClick])

  return (
    <div ref={siderRef}>
      <ThemedSider
        Title={({ collapsed }) => {
          const darkBgLogo = collapsed ? iconWhite : logoWhite
          const lightBgLogo = collapsed ? iconBlack : logoBlack
          return (
            <div style={{ padding: collapsed ? '0 4px' : '0 16px' }}>
              <img
                src={isDark ? darkBgLogo : lightBgLogo}
                alt="Fluence"
                height={28}
              />
            </div>
          )
        }}
        render={({ items, logout, collapsed }) => (
          <>
            {items}
            <div
              style={{
                marginTop: 'auto',
                padding: collapsed ? '12px 8px' : '12px 16px',
                borderTop: `1px solid ${token.colorBorderSecondary}`,
                display: 'flex',
                flexDirection: 'column',
                gap: 8,
              }}
            >
              <ThemeSwitcher collapsed={collapsed} />
              <ResetCacheButton collapsed={collapsed} />
            </div>
            {logout}
          </>
        )}
      />
    </div>
  )
}
